export const RegisterTypeOptions = [
  { id: 1, value: "static", label: "Static" },
  { id: 2, value: "dynamic", label: "Dynamic" },
];
